module.exports = __webpack_public_path__ + "media/wyposazenie/zabezpieczenia-white-8b75e6f6.png";